import { TimeseriesClosestPoint } from './find-closest-points.js';

export const EMPTY_DATAPOINT: TimeseriesClosestPoint = {
  id: 'nothing',
  x: 0,
  y: 0,
  datapoint: {
    value: 0,
    end: new Date(),
    start: new Date(),
  },
  color: {
    Default: 'black',
  },
};
